import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ClosableWrapper',
  setup(__props) {

  const isVisible = ref(true);

return { __sfc: true,isVisible }
}

})